import { createContext, useContext } from 'react';

// BILLING_ENABLED from /admin/me, provided by the shell. While billing is
// paused (Q65) the fee gate and credit warnings step aside: activation alone
// makes a company active and intros use no credit.
export const BillingEnabledContext = createContext(true);

export function useBillingEnabled(): boolean {
  return useContext(BillingEnabledContext);
}
